module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="dialog-common"><div class="outtime sma"><p> ' +
((__t = (title)) == null ? '' : __t) +
' </p><p> ' +
((__t = (msg)) == null ? '' : __t) +
' </p><div class="btn"><a href="javascript:void(0)" class="close">我知道了</a></div></div></div>';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./modules/mask/activty.end.html
// module id = 28
// module chunks = 0